import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getLanguageInformationStart,
  getLanguageInformationSuccess,
  getLanguageInformationFailed,
} from "../redux/getLanguageInformation";

import { getLanguageInformationApi } from "core/http/service/personnelInformation";

function* getLanguageInformationWork() {
  try {
    const res = yield call(getLanguageInformationApi);

    yield put({
      type: getLanguageInformationSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getLanguageInformationFailed.type,
    });
  }
}

function* watchGetLanguageInformation() {
  yield takeLatest(
    getLanguageInformationStart.type,
    getLanguageInformationWork
  );
}

export default function* getLanguageInformationSaga() {
  yield all([watchGetLanguageInformation()]);
}
